import {
  Button,
  Dialog,
  DialogTitle,
  Grid,
  IconButton,
  TextField,
} from "@mui/material";
import { QRCodeCanvas } from "qrcode.react";
import React, { useContext, useEffect, useRef, useState } from "react";
import { UserContext } from "../contexts/userContext";

const CreateQRModal = ({ handleClose, open }: any) => {
  const { businessData } = useContext(UserContext);
  const [text, setText] = useState("");

  // Referencia para acceder al elemento <canvas> del código QR
  const qrRef = useRef<HTMLCanvasElement | null>(null);

  // --- Lógica para Generar el QR ---
  const handleGenerate = () => {
    setText(`https://tresoapp.com/public-menu/${businessData.uid}`);
  };

  // --- Lógica para Descargar el QR ---
  const handleDownload = () => {
    // 1. Acceder al elemento Canvas a través de la referencia
    const canvas = qrRef.current;

    if (canvas) {
      // 2. Convertir el contenido del Canvas a una URL de datos (Data URL)
      const imageURL = canvas.toDataURL("image/png");

      // 3. Crear un enlace temporal para forzar la descarga
      const link = document.createElement("a");
      link.href = imageURL;
      link.download = "codigo_qr_generado.png"; // Nombre del archivo

      // 4. Simular un clic en el enlace y luego removerlo
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  };

  return (
    <Dialog onClose={handleClose} open={open} maxWidth="sm">
      <IconButton onClick={handleClose} className="close-icon">
        <span className="material-symbols-rounded">close</span>
      </IconButton>
      <DialogTitle>Nuevo QR</DialogTitle>
      <Grid
        container
        spacing={3}
        display="flex"
        justifyContent="center"
        sx={{ p: 5 }}
      >
        <Grid size={12}>
          {text ? (
            <Button variant="contained" fullWidth onClick={handleDownload}>
              Descargar QR
            </Button>
          ) : (
            <Button variant="contained" fullWidth onClick={handleGenerate}>
              Generar QR
            </Button>
          )}
        </Grid>
        {text && (
          <Grid size={12} display="flex" justifyContent="center">
            <QRCodeCanvas
              value={text}
              // size={512}
              level="H" // Nivel de corrección de errores (H = Alto)
              ref={qrRef} // Asignamos la referencia
            />
          </Grid>
        )}
      </Grid>
    </Dialog>
  );
};

export default CreateQRModal;
